import React, {useEffect} from 'react'
import SearchBarView from './search-bar.view'
import { Observer } from 'mobx-react-lite'
import {useAppStore} from "../../../app/store";
import SearchBarController from "../../interfaces/controllers/search-bar.controller";

const SearchBarContainer: React.FC = () => {
  const store = useAppStore()
  const controller = new SearchBarController(store)

  const handleLocationChange = (lat: number, lng: number) => {
    controller.changeLocation(lat, lng)
  }

  return (
    <Observer>
      {() => {
        return (
          <SearchBarView onSelectLocation={handleLocationChange} />
        )
      }}
    </Observer>
  )
}

export default SearchBarContainer
